import { render } from "./accept_money.vue?vue&type=template&id=87501702&scoped=true"
import script from "./accept_money.vue?vue&type=script&lang=js"
export * from "./accept_money.vue?vue&type=script&lang=js"

import "./accept_money.vue?vue&type=style&index=0&id=87501702&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87501702"]])

export default __exports__